import {
  Body,
  Button,
  CardAction,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@e2n/ui/v2';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import type { MitarbeiterabgleichZusammenfassung } from '../../hooks/useMitarbeiterabgleich/entities/Mitarbeiterabgleich';

export function AbgleichKopf({
  zusammenfassung: { uebereinstimmend, gesamt, letzterAbruf },
  abweichungen,
}: {
  zusammenfassung: MitarbeiterabgleichZusammenfassung;
  abweichungen: number;
}) {
  const { t } = useTranslation();

  return (
    <CardHeader>
      <CardTitle className="text-sm leading-5">
        {t('domain.datev.abgleich.title', { uebereinstimmend, gesamt })}
      </CardTitle>
      <CardDescription className="text-xs leading-4">
        {t('domain.datev.abgleich.abweichungen', { count: abweichungen })}
      </CardDescription>
      <CardAction className="flex flex-col items-end gap-2">
        <Button>{t('domain.datev.abgleich.abrufStarten')}</Button>
        <Body size="sm" className="text-labels-secondary">
          {t('domain.datev.abgleich.letzterAbruf', {
            datum: dayjs(letzterAbruf).format('DD.MM.YYYY, HH:mm'),
          })}
        </Body>
      </CardAction>
    </CardHeader>
  );
}
